export const CHAT_MODES = Object.freeze({
  DISABLED: "disabled",
  DIAGNOSTIC: "diagnostic",
  TUTOR: "tutor",
});

const FORBIDDEN_DIAGNOSTIC_PATTERNS = [
  /\buse\s+integration\s+by\s+parts\b/i,
  /\buse\s+u-?sub\b/i,
  /\buse\s+substitution\b/i,
  /\buse\s+partial\s+fractions\b/i,
  /\buse\s+trig\s+substitution\b/i,
  /\blet\s+[a-zA-Z]\s*=/i,
  /\bset\s+[a-zA-Z]\s*=/i,
  /\bsolution\s+is\b/i,
  /\banswer\s+is\b/i,
  /\bfinal\s+answer\b/i,
];

export const containsForbiddenDiagnostic = (message = "") =>
  FORBIDDEN_DIAGNOSTIC_PATTERNS.some((pattern) => pattern.test(message));

export const sanitizeGuidanceResponse = (message = "", mode) => {
  const trimmed = String(message || "").trim();
  if (!trimmed) return trimmed;
  if (mode !== CHAT_MODES.DIAGNOSTIC) return trimmed;
  if (!containsForbiddenDiagnostic(trimmed)) return trimmed;
  return "I can help diagnose: what have you tried, what feels unclear, and where did you get stuck?";
};

export const getChatMode = ({
  isBreakMode,
  planSubmittedAt,
  showReview,
} = {}) => {
  if (isBreakMode) return CHAT_MODES.DISABLED;
  if (!planSubmittedAt) return CHAT_MODES.DISABLED;
  if (showReview) return CHAT_MODES.TUTOR;
  return CHAT_MODES.DIAGNOSTIC;
};

export const getChatModeLabel = (mode) => {
  if (mode === CHAT_MODES.TUTOR) return "Tutor mode";
  if (mode === CHAT_MODES.DIAGNOSTIC) return "Diagnostic-only mode";
  return "Unavailable";
};
